<app-button [disabled]="disable" (buttonClick)="exportToCsv()" color="naked">
  <app-icon start name="download"></app-icon>
</app-button>
